export default "__VITE_ASSET__X5W7m6fO__"